import NextLink from 'next/link';

import { selectTagsById } from 'features/tags/slice';
import { useSelector } from 'react-redux';

import {
  Card,
  formatDate,
  Heading,
  Rule,
} from '@frontendmentorio/design-system-v2';

import Flag from 'features/shared/Flag';
import Tags from 'features/solutions/Tags';

export default function SolutionCard({ solution }) {
  const tags = useSelector((state) => selectTagsById(state, solution?.tags));

  return (
    <Card tagName="li">
      <Card.Flags>{solution.private && <Flag type="private" />}</Card.Flags>

      <Card.Image
        href={`/solutions/${solution.slug}`}
        src={solution.screenshot}
      />

      <div className="flex flex-col gap-4 p-5">
        <NextLink
          className="hover:underline"
          href={`/solutions/${solution.slug}`}
        >
          <Heading level="5" tagName="h3">
            {solution.title}
          </Heading>
        </NextLink>

        <Tags tags={tags} />
        <Rule tagName="span" />

        <span className="text-sm">
          Submitted {formatDate(solution.submittedAt)}
        </span>
      </div>
    </Card>
  );
}
